var React = require('react');

function Ae (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#00732f","d":"M0 0h640v160H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 160h640v160H0z","key":1}),React.createElement("path",{"d":"M0 320h640v160H0z","key":2}),React.createElement("path",{"fill":"red","d":"M0 0h220v480H0z","key":3})]);
}

Ae.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ae;

Ae.default = Ae;
